import type { INotification } from './types';

import randomId from '@snowit/utils/randomId';

import { create } from 'zustand';

export type StoredNotification = INotification & { id: string };

type NotificationsStore = {
  notifications: StoredNotification[];
  setNotifications: (
    update: StoredNotification[] | ((notifications: StoredNotification[]) => StoredNotification[]),
  ) => void;
  removeNotification: (id: string) => void;
};

export const useNotificationsStore = create<NotificationsStore>((set) => ({
  notifications: [],
  setNotifications: (update) => {
    set((state) => ({
      notifications: typeof update === 'function' ? update(state.notifications) : update,
    }));
  },
  removeNotification: (id) => {
    set((state) => ({
      notifications: state.notifications.filter((notification) => notification.id !== id),
    }));
  },
}));

export const notify = (params: INotification, uid?: string) => {
  const id = uid || randomId();

  useNotificationsStore.getState().setNotifications((notifications) => {
    const existing = notifications.some((notification) => notification.id === id);

    if (existing) {
      return notifications.map((notification) =>
        notification.id === id ? { ...notification, ...params, id } : notification,
      );
    }

    return [...notifications, { ...params, id }];
  });

  return id;
};
